import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  WorkTitle,
  WorkTitleFilters,
  listWorkTitles,
} from "../orders/orderAPI";

import { RootState } from "../../app/store";

//redux toolkit check it out
const workTitleAdapter = createEntityAdapter<WorkTitle>({});

export const fetchWorkTitles = createAsyncThunk<
  Array<WorkTitle>,
  WorkTitleFilters,
  { state: RootState }
>("order/fetchWorkTitles", async (filters: WorkTitleFilters, { requestId }) => {
  const response = await listWorkTitles(filters, { requestId });
  return response;
});

export type SliceState = {
  ids: [];
  entities: {};
  status: "idle" | "pending" | "succeeded" | "failed";
  error?: string;
};

export const workTitleSlice = createSlice({
  name: "workTitles",
  initialState: workTitleAdapter.getInitialState({
    status: "idle",
  }) as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkTitles.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchWorkTitles.fulfilled, (state, action) => {
        workTitleAdapter.setAll(state, action.payload);
        state.status = "succeeded";
      })
      .addCase(fetchWorkTitles.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const {
  selectAll: selectAllWorkTitles,
  selectById: selectWorkTitleById,
} = workTitleAdapter.getSelectors((state: RootState) => state.workTitles);
export default workTitleSlice.reducer;
